module.exports = __webpack_public_path__ + "img/react.45dfd355.svg";